__webpack_require__.p = "https://tastermpoint-mfe-account-stage.maersk.io/mfe/account/";